import { useEffect, useState } from 'react'

import scriptjs from 'scriptjs'
import CkEditorTextbox from '@scoir/components-core/dist/components/CkEditorTextbox'

import window from 'browser-lib/window'

export const useLoadCkEditor = (): boolean => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    let unmounted = false
    scriptjs(CkEditorTextbox.config.CDN, () => {
      if (unmounted) return
      window.CKEDITOR.config.startupFocus = false
      window.CKEDITOR.config.versionCheck = false
      setIsLoaded(true)
    })
    return () => {
      unmounted = true
    }
  }, [])

  return isLoaded
}
